"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedback = void 0;
exports.feedback = {
    pageHeading: "Leave us Feedback",
    successHeading: "Thank you for your feedback",
    trustPilotHeading: "You can also leave us a Trustpilot rating and copy your feedback below too.",
    labels: {
        collectionReference: "Collection Reference",
        rating: "Overall, how happy were you with our service?",
        name: "Your name or company name",
        email: "Email Address",
        message: "Message",
        emailOptIn: "Email Opt-In",
        emailOptInInfo: "Send me info about discounts, new services and major updates.",
        optionalQuestions: "Optional Feedback Questions (Staff, Experience and others)",
        driverComments: "Any specific comments about the drivers who collected?",
        paymentMethod: "If you made any additional payments today what method did you use?",
        improvementSuggestions: "Anything we could improve on to make your experience easier?",
        preferredContact: "Preferred method of contact for collections",
        submitButton: "Send feedback",
        paymentMethodPlaceholder: "Select a payment method...",
        preferredContactPlaceholder: "Select a contact method...",
        yourRatings: "Your ratings",
        yourMessage: "Your message",
        copyButton: "Copy your feedback",
    },
    placeholders: {
        message: "If you have time, please let us know any specific comments or feedback you may have?",
    },
    errors: {
        failedRequest: "Sorry, something went wrong when processing your request.",
    },
};
